import { render } from "./SocialSharing.vue?vue&type=template&id=08adc29a&scoped=true"
import script from "./SocialSharing.vue?vue&type=script&lang=js"
export * from "./SocialSharing.vue?vue&type=script&lang=js"

import "./SocialSharing.vue?vue&type=style&index=0&id=08adc29a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08adc29a"]])

export default __exports__